import '@farol-ds/react/index.css'

import { FarolProvider } from '@farol-ds/react'
import { Topbar, UserMenuSlotContext, UserMenuSlotRenderer } from '@jusbrasil/topbar'
import { ApolloProvider } from '@jusbrasil-web/core-apollo'
import { configureReportWebVitals } from '@jusbrasil-web/core-next'
import { NextFarolProvider } from '@jusbrasil-web/core-next/farol'
import { AppRootProvider } from '@jusbrasil-web/shared-app-root-provider'
import { isFrameBusPage } from '@jusbrasil-web/shared-frame-bus'
import { GTMProvider } from '@jusbrasil-web/shared-gtm'
import {
  CompleteSignupNudgeAvatarSlot,
  CompleteSignupNudgeProvider,
} from '@jusbrasil-web/shared-identity-validation'
import { AppProps } from 'next/app'
import Head from 'next/head'

const renderUserMenuSlot: UserMenuSlotRenderer = (avatar) => (
  <CompleteSignupNudgeAvatarSlot>{avatar}</CompleteSignupNudgeAvatarSlot>
)

function CustomApp({ Component, pageProps }: AppProps) {
  if (isFrameBusPage(pageProps)) {
    return <Component {...pageProps} />
  }

  return (
    <AppRootProvider pageProps={pageProps}>
      <Head>
        <title>Welcome to docview!</title>
      </Head>

      <NextFarolProvider />

      <FarolProvider experimental={{ flags: pageProps.farolFlags }}>
        <Topbar.Provider pageProps={pageProps}>
          <GTMProvider appId="web-docview" contentGroup="document" />
          <ApolloProvider pageProps={pageProps}>
            <CompleteSignupNudgeProvider basePath="/web/docview">
              <UserMenuSlotContext.Provider value={renderUserMenuSlot}>
                <Component {...pageProps} />
              </UserMenuSlotContext.Provider>
            </CompleteSignupNudgeProvider>
          </ApolloProvider>
        </Topbar.Provider>
      </FarolProvider>
    </AppRootProvider>
  )
}

export const reportWebVitals = configureReportWebVitals()

export default CustomApp
